import React from 'react'

export default function index() {
    return (
        <p><b>404 Not Found !</b></p>
    )
}
